export function isReload() {
    var _a;
    return (((_a = performance
        .getEntriesByType("navigation")
        .map((entry) => entry)
        .at(0)) === null || _a === void 0 ? void 0 : _a.type) === "reload");
}
